import React from 'react'
import classNames from 'classnames'
import { message } from 'antd'
import { cdnImg } from 'meinian-package/src/utils/image'
import request from 'meinian-package/src/utils/request'
import logo from 'image/logo_icon.png'
import { SCREEN_VALUE } from '../../view/home/recycle'
import './recoverCard.less'

export default (props) => {
  const { columnWidth, mainUrl, screenValue, className, deletedUserName, inspirationName, collectId,
    inspirationId, timeRemaining, blogNum, parentInspirationName, title, setData, onResize } = props

  const recover = async (_collectId, _inspirationId) => {
    try {
      if (screenValue == SCREEN_VALUE.STYLE) {
        await request.post('/zhikuan/mn/recycle-bin/recover-inspiration-blog', { collectId: _collectId, inspirationId: _inspirationId })
        message.success('恢复成功')
      } else {
        await request.post('/zhikuan/mn/recycle-bin/recover-inspiration', { collectId: _collectId, inspirationId: _inspirationId })
        message.success('恢复成功')
      }
      _onChange({ collectId, inspirationId })
    } catch (err) {
      console.error(err)
    }
  }

  const _onChange = (itemParams) => {
    if (screenValue === SCREEN_VALUE.STYLE) {
      setData?.((pre) => {
        return pre.filter(item => item.collectId !== itemParams?.collectId)
      })
    } else {
      setData?.((pre) => {
        return pre.filter(item => item.inspirationId !== itemParams?.inspirationId)
      })
    }
    onResize?.()
  }
  return (
    <div style={{ width: columnWidth, height: columnWidth + 52, padding: '8px', background: '#fff', borderRadius: '6px' }}>
      <div className={classNames('meinian-waterfall-card-recycle', className)}>
        {mainUrl ? <img src={cdnImg(mainUrl, 500)} style={{ width: '100%', height: '100%', objectFit: 'cover', background: 'linear-gradient(rgba(0,0,0,0.03), rgba(0,0,0,0.03))' }} /> : <div className="empty"><img src={logo} /></div>}
        <div className="count-down">{timeRemaining}</div>
        <div className="recycle-mask">
          <div className="mask-info">
            {screenValue == SCREEN_VALUE.INSPIRATION ? <div className="inspiration">
              <span>{title}</span>
              <span>{blogNum}款式</span>
            </div> : null}
            <div className="delete-info">
              <span className="delete-info-name text-overflow">{deletedUserName}</span>
              <span>删除</span>
            </div>
            <div className="inspiration-info">
              {screenValue == SCREEN_VALUE.INSPIRATION && parentInspirationName ? <>
                <span>上级灵感集：</span>
                <span>{parentInspirationName}</span>
              </> : null}
              {screenValue == SCREEN_VALUE.STYLE && <>
                <span>来自</span>
                <span>{inspirationName}</span>
                </>}
            </div>
            <div className="recover-btn" onClick={() => recover(collectId, inspirationId)}>恢复</div>
          </div>
        </div>
      </div>
    </div>
  )
}
